import { css } from "@emotion/css";
import { GongShowCalculator } from "./GongShowCalculator";
import { RaceDescriptions } from "./RaceDescriptions";
import { LIGHT_GREY } from "./colors";

export const App = () => {
  return (
    <div
      className={css(`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
      height: 100vh;
      width: 100vw;
      overflow: hidden;
      scroll: none;
      color: ${LIGHT_GREY.hex()};
      background-color: #142d4c;
          `)}
    >
      <h2>Matti's Race Night</h2>
      <RaceDescriptions />
    </div>
  );
};
